/* eslint-disable */
import store from '@/store'
import { firebase } from '@firebase/app'
import '@firebase/firestore'
import '@firebase/auth'
import config from 'appconfig'
import namisconfig from 'namisconfig'
import '@firebase/storage'
import '@firebase/functions'
import { startsWith, flatten, isEqual } from 'lodash'

const USER_COLLECTION = "Users"
firebase.initializeApp(config.firebase)
var namis = firebase.initializeApp(namisconfig.firebase, 'namis')
// firebase.functions().useFunctionsEmulator('http://localhost:5000')
const autoLoginNaf = () => {
  if(startsWith(window.location.hash, '#/?email=')) {
    $auth.loginNafoods()
  }
}
firebase.auth().onAuthStateChanged(async (userRoot) => {
  namis.auth().onAuthStateChanged(async (userNamis) => {
    if(userRoot && !userNamis) {
      await firebase.functions().httpsCallable('generateToken')().then(async res => {
        await namis.auth().signInWithCustomToken(res.data)
      }).catch(err => {
        console.log(err)
      })
    }
    let user = userRoot || userNamis
    if(userNamis && !userRoot) {
      await (firebase.functions().httpsCallable('generateToken2')({
        email: userNamis.email,
        uid: userNamis.uid
      })).then(async res => {
        await firebase.auth().signInWithCustomToken(res.data)
      }).catch(err => {
        console.log(err)
      })
    }
    if (user) {
      await syncUser(user)
      let p = $query(['Users', user.email])
      let f = $query(['Masterdata', 'Farm'])
      let m = $query(['Masterdata', 'Meka'])
      let j = $query(['Masterdata', 'Jobs'])
      Promise.all([p, f, m, j]).then(res => {
        if (!res[0]) res[0] = { groups: [] };
        res[0].groups = flatten([res[0].groups, "logged"]);
        store.dispatch("registerPermission", res[0]);
        store.dispatch('registerUser', user)
        store.dispatch('registerFarm', res[1])
        store.dispatch('registerMeka', res[2])
        store.dispatch('registerJobs', res[3])
      })
    } else {
      store.dispatch('registerUser', null)
      store.dispatch('registerPermission', null)
      autoLoginNaf()
    }
  })
})

const $auth = {
  login: function (email, password) {
    try {
      return firebase.auth().signInWithEmailAndPassword(email, password)
    } catch (err) {
      console.log(err)
    }
  },
  loginNafoods: function () {
    const provider = new firebase.auth.GoogleAuthProvider()
    provider.setCustomParameters({ 'prompt': 'select_account' })
    provider.setCustomParameters({ 'login_hint': '@nafoods.com' })
    provider.setCustomParameters({ 'hd': 'nafoods.com' })
    provider.addScope('https://www.googleapis.com/auth/calendar.readonly')
    return namis.auth().signInWithRedirect(provider)
  },
  logout: function () {
    firebase.auth().signOut()
    namis.auth().signOut()
  },
  resetPass: (email) => {
    return firebase.auth().sendPasswordResetEmail(email)
  }
}

const syncUser = async function (user) {
  let naTbDoc = await firebase.firestore().collection(`${USER_COLLECTION}`).doc(`${user.email}`).get()
  let namisDoc = await firebase.apps[1].firestore().collection(`${USER_COLLECTION}`).doc(`${user.email}`).get()
  if (naTbDoc.exists && namisDoc.exists) {
    return
  }
  return firebase.functions().httpsCallable('syncUserToNamis')({collection:USER_COLLECTION, document:user.email,data: naTbDoc.data()})
}

const firestore = firebase.firestore()
const namisFirestore = namis.firestore()
const is2dArray = array => Array.isArray(array) ? array.every(item => Array.isArray(item)) : false;
const $query = function (reference, filter, order, limit, after, returnSnapshot, app) {
  let ref = app === 'namis' ? namisFirestore : firestore
  let isCollection = false
  reference.forEach(function (id) {
    isCollection = !isCollection
    if (isCollection) {
      ref = ref.collection(id)
    } else {
      ref = ref.doc(id)
    }
  })
  let res_
  if (!isCollection) {
    res_ = ref.get().then(function (doc) {
      return doc.data()
    })
  } else {
    if (filter) {
      filter.forEach(function (condition) {
        ref = ref.where(condition[0], condition[1], condition[2])
      })
    }
    if (order && !is2dArray(order)) {
      ref = ref.orderBy(order[0], order[1])
    } else if(order && is2dArray(order)) {
      order.forEach(item => ref = ref.orderBy(item[0], item[1]))
    }
    if (after) { 
      ref = ref.startAfter(after)
    }
    if (limit) {
      ref = ref.limit(limit)
    }
    res_ = ref.get().then(function (querySnapshot) {
      let docs = []
      querySnapshot.forEach(function (doc) {
        docs.push(Object.assign({ _id: doc.id, _createTime: doc._document.proto.createTime }, doc.data()))
      })
      let returnObj = {
        data: docs
      }
      if(returnSnapshot) returnObj.docsSnapshot = querySnapshot
      return returnObj
    })
  }
  return res_.catch(function (error) {
    return {
      error: error
    }
  })
}

const $getNameById = function (collection, val, nameField) {
  for (let i in collection) {
    if (isEqual(collection[i].id, val)) {
      return collection[i][nameField]
    }
  }
  return ''
}

const $storage = firebase.storage()

export default {
  // eslint-disable-next-line no-unused-vars
  install (Vue, options) {
    Vue.prototype.$auth = $auth
    Vue.prototype.$query = $query
    Vue.prototype.$storage = $storage
    Vue.prototype.$getNameById = $getNameById
    Vue.prototype.$namis = namis
  },
  namis: namis
}

